import { format } from 'date-fns'
import { TOOLTIP } from '../../../../constants/tooltips'
import { DISPLAY_DATE_FORMAT, INTERNAL_DATE_FORMAT } from '../../../services/constants'
import { parseDate } from '../../aoraki/generic-search-common/src'
import LookupField from '../../wells/lookup-field'
import { AquiferEditFormInterface } from './aquifer-test-details-edit'
import { DateField, FormField, Heading, InputWidth, TextInput } from '@msaf/core-react'

export default function TestAnalysisEditForm({
  fields,
  isLoading,
  setValue,
  wellId,
}: AquiferEditFormInterface & { wellId: string }) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Test analysis
      </Heading>

      <FormField isSkeleton={isLoading} label='Analysis method' labelId='analysisMethodLabel'>
        <LookupField
          isSkeleton={isLoading}
          fieldId='analysisMethod'
          labelledBy='analysisMethodLabel'
          value={`${fields.analysisMethod ?? ''}`}
          setValue={({ value }) => setValue('analysisMethod', value)}
        />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.testAnalysisPerson}
        isSkeleton={isLoading}
        label='Test analysis by'
        htmlFor='testAnalysisPerson'
      >
        <TextInput
          id='testAnalysisPerson'
          isSkeleton={isLoading}
          value={`${fields.testAnalysisPerson ?? ''}`}
          setValue={(value) => setValue('testAnalysisPerson', value)}
        />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.reportNo}
        isSkeleton={isLoading}
        label='Report reference'
        htmlFor='reportReference'
      >
        <TextInput
          isSkeleton={isLoading}
          id='reportReference'
          value={`${fields.reportNo ?? ''}`}
          setValue={(value) => setValue('reportNo', value)}
        />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.dataReference}
        isSkeleton={isLoading}
        label='Data reference'
        htmlFor='dataReference'
      >
        <TextInput
          isSkeleton={isLoading}
          id='dataReference'
          value={`${fields.dataReference ?? ''}`}
          setValue={(value) => setValue('dataReference', value)}
        />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.testReviewedByPerson}
        isSkeleton={isLoading}
        label='Test reviewed by'
        htmlFor='testReviewedByPerson'
      >
        <TextInput
          id='testReviewedByPerson'
          isSkeleton={isLoading}
          value={`${fields.testReviewedByPerson ?? ''}`}
          setValue={(value) => setValue('testReviewedByPerson', value)}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='Test review date' htmlFor='testReviewDate'>
        <DateField
          isSkeleton={isLoading}
          isDisabled={isLoading}
          fieldSize={InputWidth.large}
          dateFormat={DISPLAY_DATE_FORMAT}
          selectedDate={parseDate(fields.testReviewDate)}
          setSelectedDate={(date: Date) => setValue('testReviewDate', date ? format(date, INTERNAL_DATE_FORMAT) : '')}
        />
      </FormField>
    </>
  )
}
